import axios from "axios";
import { getTelegramInitData, getTelegramStartParam, getTelegramWebApp, safeLocalStorage, safeSessionStorage } from "@/lib/telegram";

const URL_TRACK = `${process.env.REACT_APP_BACKEND_URL}/api/track`;
const ANON_KEY = "appway_anon";
let queue = [];
let timer = null;
let installed = false;

const anonId = () => {
  let id = safeLocalStorage.get(ANON_KEY);
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    safeLocalStorage.set(ANON_KEY, id);
  }
  return id;
};

const isAdmin = () => window.location.pathname.startsWith("/admin");

const payload = (events) => ({
  events,
  wb: safeSessionStorage.get("appway_wb") || "",
  init_data: getTelegramInitData(),
  anon: anonId(),
});

const flush = (beacon = false) => {
  clearTimeout(timer);
  timer = null;
  if (!queue.length) return;
  const body = payload(queue.splice(0, 30));
  if (beacon && navigator.sendBeacon) {
    navigator.sendBeacon(URL_TRACK, new Blob([JSON.stringify(body)], { type: "application/json" }));
  } else {
    axios.post(URL_TRACK, body).catch(() => {});
  }
};

export const track = (type, label = "", details = {}) => {
  if (isAdmin()) return;
  queue.push({ type, label: String(label).slice(0, 200), path: window.location.pathname, details });
  if (queue.length >= 10) flush();
  else if (!timer) timer = setTimeout(flush, 2000);
};

const PAGES = [
  [/^\/prosto\/guide/, "Гайд установки"],
  [/^\/prosto\/search/, "Поиск ProstoApp"],
  [/^\/prosto\/category\/(.+)/, (m) => `Категория «${decodeURIComponent(m[1])}» (ProstoApp)`],
  [/^\/prosto\/app\//, "Карточка приложения (ProstoApp)"],
  [/^\/prosto\/?$/, "Главная ProstoApp"],
  [/^\/search/, "Поиск AppWay"],
  [/^\/collections/, "Подборки AppWay"],
  [/^\/category\/(.+)/, (m) => `Категория «${decodeURIComponent(m[1])}» (AppWay)`],
  [/^\/app\//, "Карточка приложения (AppWay)"],
  [/^\/?$/, "Главная AppWay"],
];

export const pageLabel = (path) => {
  for (const [rx, l] of PAGES) {
    const m = path.match(rx);
    if (m) return typeof l === "function" ? l(m) : l;
  }
  return path;
};

const clickLabel = (el) =>
  (el.innerText || el.getAttribute("aria-label") || el.getAttribute("title") || el.querySelector("img")?.alt || "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 80);

export const installTracker = () => {
  if (installed) return;
  installed = true;
  const tg = getTelegramWebApp();
  track("open", "Открыл витрину", {
    platform: tg?.platform && tg.platform !== "unknown" ? tg.platform : "web",
    start_param: getTelegramStartParam(),
  });
  document.addEventListener(
    "click",
    (e) => {
      const el = e.target.closest?.("button, a, [role='button']");
      if (!el) return;
      if (el.hasAttribute("data-track-manual")) return;
      const tid = el.getAttribute("data-testid") || el.closest("[data-testid]")?.getAttribute("data-testid") || "";
      track("click", clickLabel(el) || tid, { testid: tid });
    },
    true
  );
  let searchT = null;
  document.addEventListener(
    "input",
    (e) => {
      const el = e.target;
      const tid = el?.getAttribute?.("data-testid") || "";
      if (el?.tagName !== "INPUT" || !/search/i.test(tid + (el.type || ""))) return;
      clearTimeout(searchT);
      searchT = setTimeout(() => {
        const q = el.value.trim();
        if (q) track("search", `Ищет «${q.slice(0, 60)}»`, { query: q.slice(0, 100) });
      }, 1200);
    },
    true
  );
  window.addEventListener("pagehide", () => flush(true));
  document.addEventListener("visibilitychange", () => document.visibilityState === "hidden" && flush(true));
};
